import { render, staticRenderFns } from "./ItemAdjustments.vue?vue&type=template&id=3f5d5f84"
import script from "./ItemAdjustments.vue?vue&type=script&lang=js"
export * from "./ItemAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports